import { useState } from 'react';
import { CheckboxCard, CheckboxCardGroup, Icon, Stack, Text } from 'shell/components';

const OPTIONS = [
    {
        key: 'documents',
        label: 'Documents',
        description: 'Document files and text entries',
        icon: 'fileTypeUndefined',
    },
    {
        key: 'videos',
        label: 'Videos',
        description: 'Video files and hosted recordings',
        icon: 'video',
    },
    {
        key: 'slides',
        label: 'Slides',
        description: 'Presentation files',
        icon: 'presentation',
    },
];

const CheckboxCardDemo = () => {
    const [selected, setSelected] = useState(['documents']);

    return (
        <Stack spacing={3} sx={{ width: 520, maxWidth: '100%' }}>
            <Text variant={'sh1'}>CheckboxCard</Text>
            <CheckboxCardGroup
                label={'Select supported formats'}
                description={'Select one or more options.'}
                descriptionSx={{ mt: 5 }}
                gridSx={{ mt: 5 }}
            >
                {OPTIONS.map((option) => {
                    const checked = selected.includes(option.key);
                    return (
                        <CheckboxCard
                            key={option.key}
                            checked={checked}
                            icon={<Icon kind={option.icon} />}
                            label={option.label}
                            description={option.description}
                            onChange={() =>
                                setSelected((current) =>
                                    checked ? current.filter((value) => value !== option.key) : [...current, option.key]
                                )
                            }
                        />
                    );
                })}
            </CheckboxCardGroup>
        </Stack>
    );
};

export default CheckboxCardDemo;
